export default __webpack_public_path__ + "static/media/covered_icon.7be85692.png";